module.exports = __webpack_public_path__ + "media/images/woman-browser-icon-6a088a97.png";